module.exports = __webpack_public_path__ + "static/media/delete-button-inverted.f0ba8de9.svg";